<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Avatar from "@/components/widgets/avatar";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'My Account': 'Minha Conta',
      'Username': 'Usuário',
      'Name': 'Nome',
      'Cellphone': 'Celular',
      'Password': 'Senha',
    },
    es: {
      'My Account': 'Mi Cuenta',
      'Username': 'Nombre de Usuario',
      'Name': 'Nombre',
      'Cellphone': 'Celular',
    }
  },
  components: {
    Layout,
    Avatar
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      cancel: {
        modal: false,
        loading: false,
        reason: '',
      }
    };
  },
  methods: {
    showCancel() {
      this.cancel.modal = false
      this.cancel.modal = true
    },
    cancelAccount() {
      this.cancel.loading = true
      this.cancel.reason = ''

      api
        .post('user/cancel', {
          reason: this.cancel.reason
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(response.data.message)
            this.cancel.modal = false
            this.cancel.loading = false
            this.$router.push('/login')
          } else {
            this.cancel.modal = false
            this.cancel.loading = false
            this.$toast.error(response.data.message)
          }
        })
    }
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('My Account') }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="account && account.user" class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <Avatar></Avatar>
          </div>
          <div class="col-md-8 pt-md-5">
            <div class="row pt-3 pb-0 pl-3 pr-3">
              <div v-if="account.user.name" class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">Código de Indicação</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.indication }}</p>
              </div>
              <div v-if="account.user.name" class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Name') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.name }}</p>
              </div>
              <div v-if="account.user.person && account.user.person.number" class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('CPF/CNPJ') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.person.number }}</p>
              </div>
              <div v-if="account.user.email.address" class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Email') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.email.address }}</p>
              </div>
              <div v-if="account.user.cellphone" class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Cellphone') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.cellphone }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <button class="btn btn-outline-danger btn-lg btn-block" v-on:click="showCancel()">Excluir Conta</button>
    </div>

    <b-modal v-model="cancel.modal" modal-class="modal-right" title="Excluir Conta" hide-footer>
      <b-form @submit.prevent="cancelAccount">
        <h4>Deseja realmente excluir sua conta?</h4>
        <p class="text-danger">Atenção! Esta ação é irreversível e irá remover todos os seus dados da plataforma.</p>
        <div class="my-5">
          <b-form-group label="Motivo" label-for="reason">
            <b-form-input id="reason" v-model="cancel.reason" type="text" placeholder="Digite o motivo da exclusão"></b-form-input>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-danger btn-lg mr-3" type="submit" :disabled="this.cancel.loading">
            Excluir Conta
            <b-spinner v-if="cancel.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </b-form>
    </b-modal>
  </Layout>
</template>